import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'fc-footer',
    templateUrl: './footer-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FooterContainerComponent {}
